import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import RankingSection from './components/RankingSection';
import CategoryBrowse from './components/CategoryBrowse';
import LatestUpdates from './components/LatestUpdates';
import CtaSection from './components/CtaSection';

export default function Home() {
  const formSubmitAddr = 'https://readdy.ai/api/form/d9on67qqs38sj6jc7btg';

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <RankingSection />
        <CategoryBrowse />
        <LatestUpdates />
        <CtaSection formSubmitAddr={formSubmitAddr} />
      </main>
      <Footer />
    </div>
  );
}